module.exports = __webpack_public_path__ + "img/RASHA-EL-SHERBINY-1.596c15af923ad068216c.596c15af.jpg";